<script setup>

import { resourceV2 } from '@/composables/resource';
import { useRoute } from 'vue-router';

import ListingContent from '@/components/Secondary/Marketplace/ListingContent.vue';
import ListingMedia from '@/components/Secondary/Marketplace/ListingMedia.vue';
import { onBeforeMount } from 'vue';

const route = useRoute();
const listing = resourceV2({
    url: `/api/marketplace/listings/${route.params.id}`,
});

onBeforeMount(() => {
    listing.fetch();
});
</script>

<template>
    <layout-main>
        <template v-if="$store.state.deviceType === 'desktop'">
            <layout-content size="lg">
                <content-body>
                    <ListingMedia v-if="listing.loadState === 'ready'" :files="listing.data.files" />
                </content-body>
            </layout-content>
            <layout-content size="sm">
                <content-header hide-border>
                    <top-nav>
                        <top-nav-back />
                    </top-nav>
                </content-header>

                <content-body>
                    <template v-if="listing.loadState === 'ready'" >
                        <ListingContent :listing="listing.data" @refresh="listing.fetch()" />
                    </template>

                    <app-layout-skeleton v-else-if="listing.loadState === 'loading'" />
                    <app-error-not-found v-else-if="listing.loadState === 'missing'" />
                    <app-error-default v-else-if="listing.loadState === 'error'" />
                </content-body>
            </layout-content>
        </template>
        <template v-else>
            <layout-content>
                <content-header>
                    <top-nav>
                        <top-nav-back />
                    </top-nav>
                </content-header>
                <content-body>
                    <template v-if="listing.loadState === 'ready'">
                        <div class="w-full h-[400px]">
                            <ListingMedia :files="listing.data.files" />
                        </div>
                        <ListingContent :listing="listing.data" @refresh="listing.fetch({ silent: true })" />
                    </template>

                    <app-layout-skeleton v-else-if="listing.loadState === 'loading'" />
                    <app-error-not-found v-else-if="listing.loadState === 'missing'" />
                    <app-error-default v-else-if="listing.loadState === 'error'" />
                </content-body>
            </layout-content>
        </template>
    </layout-main>
</template>

